import { $Q, $Qll } from "../utils/query-selector";

/**
 * Updates the range input and progress bar based on the given parameters.
 *
 * @param {Array} rangeIn - The range input elements.
 * @param {Array} priceIn - The price input elements.
 * @param {Element} progress - The progress bar element.
 * @param {number} priceGap - The price gap.
 */
// eslint-disable-next-line max-params
function updateRange(rangeIn, priceIn, progress, priceGap) {
  rangeIn.forEach((input) => {
    if (priceIn[0].value) {
      progress.style.left = `${(priceIn[0].value / rangeIn[0].max) * 10000 }%`;
      progress.style.right = `${100 - (priceIn[1].value / rangeIn[1].max) * 10000 }%`;
    }

    input.addEventListener("input", (e) => {
      const minVal = Number(rangeIn[0].value);
      const maxVal = Number(rangeIn[1].value);

      if (maxVal - minVal < priceGap) {
        if (e.target.className === "range-min") {
          rangeIn[0].value = cents(maxVal - priceGap);
        } else {
          rangeIn[1].value = cents(minVal + priceGap);
        }
      } else {
        const range1Div = $Q(".range1 div");
        const range2Div = $Q(".range2 div");
        if (range1Div) {
          range1Div.textContent = cents(minVal, true);
        }
        if (range2Div) {
          range2Div.textContent = cents(maxVal, true);
        }
        priceIn[0].value = cents(minVal, true);
        priceIn[1].value = cents(maxVal, true);
        progress.style.left = `${(minVal / rangeIn[0].max) * 100 }%`;
        progress.style.right = `${100 - (maxVal / rangeIn[1].max) * 100 }%`;
      }
    });
  });
}

/**
 *
 * we control the price range filter in order to avoid that the minimum
 * value is greater than the highest value and that the highest
 * value is not less than the lowest value
 *
 */
export function rangeFilters() {
  const rangeIn = $Qll(".range-in input");
  const priceIn = $Qll(".price-in input");
  const progress = $Q('.slider-filter .pro');
  const containerMobile = $Q("#filter-mobile")
  const rangeInMobile = $Qll(".range-in input", containerMobile);
  const priceInMobile = $Qll(".price-in input", containerMobile);
  const progressMobile = $Q('.slider-filter .pro', containerMobile);

  const priceGap = 0;

  updateRange(rangeIn, priceIn, progress, priceGap);
  updateRange(rangeInMobile, priceInMobile, progressMobile, priceGap);
}

function cents(str, fixed) {
  const number = Number(str) / 100
  if (fixed) return number.toFixed(2);
  return number
}

(function formatValues() {
  $Qll('.price-in input').forEach(
    (item) => {
      item.value = cents(item.value, true)
    }
  )
}());
